'use client';

import * as React from 'react';
import { ChevronDown, User } from 'lucide-react';

import { Avatar } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { ROUTES, SETTINGS_ROUTES } from '@/constants/routes';
import { useAppContext } from '@/context/app-context';
import { useCallback, useMemo } from 'react';
import { Menu } from '@/components/ui/menu';
import { setUserData } from '@/lib/requests/user';
// import { getStripePortalUrl } from '@/lib/requests/payment';

// FIXME: temporaily removed subscription
export default function UserPanel() {
    const { isLoading, user, goToPage, profile, setProfile } = useAppContext();

    const setDefaultView = async (view: 'investor' | 'founder') => {
        try {
            await setUserData({ default_view: view });
            setProfile((prev) => {
                if (!prev) return null;
                return { ...prev, defaultView: view };
            });
            window.location.reload();
        } catch (error) {
            console.error(error);
        }
    };

    // const [fetchingPortal, setFetchingPortal] = useState(false);
    // const [portalError, setPortalError] = useState(false);
    // const [url, setUrl] = useState<string | null>(null);

    // const getPortal = async () => {
    //     if (!profile?.hasActiveSubscription) return;
    //
    //     try {
    //         setFetchingPortal(true);
    //
    //         const { data } = await getStripePortalUrl();
    //
    //         setUrl(data.url);
    //     } catch {
    //         setPortalError(true);
    //     } finally {
    //         setFetchingPortal(false);
    //     }
    // };

    // const openPortal = useCallback(async () => {
    //     if (profile?.hasActiveSubscription && url) {
    //         window.open(url, '_blank');
    //     } else {
    //         goToPage(ROUTES.Payment);
    //     }
    // }, [profile, url, goToPage]);

    const logout = useCallback(async () => {
        goToPage(ROUTES.Logout);
    }, [goToPage]);

    const username = useMemo(
        () => user?.email?.split('@')[0] ?? 'User',
        [user],
    );

    const items = useMemo(() => {
        return [
            // {
            //     label: portalError
            //         ? 'Subscription unavailable'
            //         : 'Subscription',
            //     action: openPortal,
            //     disabled: fetchingPortal || portalError,
            // },
            profile?.defaultView !== 'investor' && {
                label: 'Settings',
                action: () => goToPage(SETTINGS_ROUTES.CompanyLogo),
            },
            profile?.defaultView !== 'investor' && {
                label: 'Plans',
                action: () => goToPage(SETTINGS_ROUTES.SubscriptionPlan),
            },
            profile?.defaultView === 'investor' && {
                label: 'Switch to Founder View',
                action: () => setDefaultView('founder'),
            },
            profile?.defaultView === 'founder' && {
                label: 'Switch to Investor View',
                action: () => setDefaultView('investor'),
            },
            { label: 'Logout', action: logout },
        ].filter(
            (
                item,
            ): item is {
                label: string;
                action: () => void;
                disabled?: boolean;
            } => Boolean(item),
        );
    }, [
        logout,
        profile?.defaultView,
        goToPage,
        // openPortal, fetchingPortal, portalError
    ]);

    const handleOpenMenu = async () => {
        // if (!url) await getPortal();
    };

    return user ? (
        <div className="flex items-center gap-4">
            <Menu onOpenMenu={handleOpenMenu} items={items}>
                <>
                    <Avatar className="h-8 w-8 border-2 border-white flex items-center justify-center mr-1">
                        <User className="h-5 w-5" />
                    </Avatar>
                    <span className="hidden md:inline-flex text-white">
                        {username}
                    </span>
                    <ChevronDown className="h-4 w-4 text-muted-foreground" />
                </>
            </Menu>
        </div>
    ) : (
        <Button
            className="w-20"
            loading={isLoading}
            disabled={isLoading}
            onClick={() => goToPage(ROUTES.Login)}
        >
            Sign in
        </Button>
    );
}
